import { validateQaEnvironment } from "./qa-environment";

/** Read the three origin-bound values through Vite's QA-only definitions too. */
export function currentQaEnvironment(currentOrigin?: string) {
  return validateQaEnvironment(
    {
      ...import.meta.env,
      VITE_QA_ENVIRONMENT: import.meta.env.VITE_QA_ENVIRONMENT,
      VITE_API_URL: import.meta.env.VITE_API_URL,
      VITE_AUTH0_CALLBACK_URL: import.meta.env.VITE_AUTH0_CALLBACK_URL,
    },
    currentOrigin
  );
}
